import React from "react";
import {
    Avatar,
    Divider,
    Dropdown,
    Flex,
    Skeleton,
    Text,
} from "@fluentui/react-northstar";
import styled from "styled-components";
import {
    BuildingBank16Filled,
    PeopleTeam16Filled,
} from "@fluentui/react-icons";
import { AVATAR_DEFAULT } from "../../../../constants";
const AvatarName = ({
    name = "",
    image = "",
    size = "medium",
    jobTitle,
    department,
    agency,
    users,
    setIdEmployeeState,
    id_employee,
    isLoadingBalanceType = true,
    isFetchingBalanceType = true,
    fromCollaborator = false,
}) => {
    let usersFormatted = [];
    if (!fromCollaborator) {
        usersFormatted = users?.map((user) => {
            return {
                id: user?.id,
                key: user?.id,
                header: user?.name,
                email: user?.username,
                content: user?.job_title,
                image: user?.avatar ?? AVATAR_DEFAULT,
            };
        });
    }

    const selectedUser = usersFormatted?.find(
        (user) => user.key === id_employee
    );

    return (
        <Flex gap="gap.medium" vAlign="center">
            {isLoadingBalanceType || isFetchingBalanceType ? (
                <Skeleton animation="pulse">
                    <Skeleton.Avatar size="largest" />
                </Skeleton>
            ) : (
                <Avatar name={name} image={image} size={size} />
            )}

            <Flex gap="gap.smaller" column>
                {fromCollaborator ? (
                    <Text content={name} styles={{ fontWeight: "600" }} />
                ) : (
                    <Dropdown
                        search
                        checkable
                        items={usersFormatted}
                        value={selectedUser}
                        defaultSearchQuery={selectedUser?.header}
                        onChange={(e, data) => {
                            setIdEmployeeState(data?.value?.id);
                        }}
                        noResultsMessage="We couldn't find any matches."
                    />
                )}

                {/* <Name content={name} /> */}
                <Flex column gap="gap.small">
                    {isLoadingBalanceType || isFetchingBalanceType ? (
                        <Skeleton animation="pulse">
                            <Skeleton.Text
                                size="medium"
                                styles={{ width: "200px" }}
                            />
                        </Skeleton>
                    ) : (
                        <JobTitleText content={jobTitle} />
                    )}
                    <DepartementAndAgencyCard
                        department={department}
                        agency={agency}
                        isLoadingBalanceType={isLoadingBalanceType}
                        isFetchingBalanceType={isFetchingBalanceType}
                    />
                </Flex>
            </Flex>
        </Flex>
    );
};

export default AvatarName;

const DepartementAndAgencyCard = ({
    department,
    agency,
    isLoadingBalanceType,
    isFetchingBalanceType,
}) => {
    return (
        <Flex gap="gap.small">
            {isLoadingBalanceType || isFetchingBalanceType ? (
                <Skeleton animation="pulse">
                    <Skeleton.Text size="medium" styles={{ width: "156px" }} />
                </Skeleton>
            ) : (
                <DepartementFlex vAlign="center">
                    <PeopleTeam16Filled color="#616161" />
                    <Divider vertical />
                    <DepartementName content={department} />
                </DepartementFlex>
            )}
            {isLoadingBalanceType || isFetchingBalanceType ? (
                <Skeleton animation="pulse">
                    <Skeleton.Text size="medium" styles={{ width: "156px" }} />
                </Skeleton>
            ) : (
                <DepartementFlex vAlign="center">
                    <BuildingBank16Filled color="#616161" />
                    <Divider vertical />
                    <DepartementName content={agency} />
                </DepartementFlex>
            )}
        </Flex>
    );
};

const JobTitleText = styled(Text)`
    color: #242424;
    font-family: "Segoe UI";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
`;

const Name = styled(Text)`
    color: #242424;
    font-family: "Segoe UI";
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
`;

const DepartementFlex = styled(Flex)`
    border-radius: 4px;
    background-color: #ebebeb;
    padding: 4px 8px;
    gap: 4px;
`;

const DepartementName = styled(Text)`
    color: #616161;
    font-family: "Segoe UI";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
`;
